<script>
import { useUserStore, useStockStore, useAppUpdateStore, useAppSystemConfigStore } from "@/stores/index.js"
import { AppCheckUpdate } from "@/api/app.js"
import { HOME_PAGE } from "@/utils/index.js"
// #ifdef H5
import { getCurrentInstance } from "vue"
// #endif
export default {
	// #ifdef H5
	// H5 的 onPageNotFound 只在启动时触发一次，且此时 uni.reLaunch 会因无页面挂载被排队挂起；
	// 统一用路由守卫兜底：未匹配任何页面（含启动和手改地址栏）时改 hash 回首页。
	// vue-router 是 @dcloudio/uni-h5 的传递依赖，pnpm 下顶层不可直接 import，从全局属性取实例
	setup() {
		const router = getCurrentInstance()?.appContext?.config?.globalProperties?.$router
		router?.afterEach((to) => {
			if (!to.matched.length) {
				window.location.replace(`#${HOME_PAGE}`)
			}
		})
	},
	// #endif
	onLaunch: function () {
		console.log('App Launch')
		const stockStore = useStockStore();
		const userStore = useUserStore();
		const appUpdateStore = useAppUpdateStore();
		const appSystemConfigStore = useAppSystemConfigStore();

		// #ifdef APP-PLUS
		appUpdateStore.onCheckForUpdate();
		// #endif

		// #ifdef H5
		appSystemConfigStore.onGetSystemBasic().catch(() => {});
		// #endif

		// 获取市场列表
		stockStore.getMarketList()

		uni.onLocaleChange(() => {
			stockStore.getMarketList();
		})

		if (userStore.token) {
			userStore.onGetUserInfo();
		}
	},
	// 路由到不存在的页面时兜底跳首页（H5 走上面的路由守卫）
	onPageNotFound: function (res) {
		// #ifndef H5
		console.error('页面不存在', res)
		const path = res.path || ''
		// 首页本身找不到就不再跳，避免死循环
		if ((path.startsWith('/') ? path : `/${path}`) === HOME_PAGE) return
		uni.reLaunch({
			url: HOME_PAGE,
			fail: (err) => console.error('[router] 兜底跳首页失败', err)
		})
		// #endif
	},
	onShow: function () {
		console.log('App Show')
	},
	onHide: function () {
		console.log('App Hide')
	}
}
</script>

<style lang="scss">
/* #ifndef APP-NVUE */
/*每个页面公共css */
@import "@/styles/index.scss";

@keyframes animred {
	0% {
		opacity: 0.1;
	}

	10% {
		opacity: 0.1;
	}

	20% {
		opacity: 0.2;
	}

	30% {
		opacity: 0.3;
	}

	40% {
		opacity: 0.4;
	}

	50% {
		opacity: 0.5;
	}

	60% {
		opacity: 0.6;
	}

	70% {
		opacity: 0.7;
	}

	80% {
		opacity: 0.8;
	}

	90% {
		opacity: 0.9;
	}

	100% {
		opacity: 0.9;
	}
}

@font-face {
	font-family: Asap;
	src: local("Asap-Regular"), url("/static/fonts/Asap-Regular.ttf") format("truetype");
	font-style: normal;
	font-display: swap;
	font-weight: 400;
}

@font-face {
	font-family: Asap;
	src: local("Asap-Medium"), url("/static/fonts/Asap-Medium.ttf") format("truetype");
	font-style: normal;
	font-display: swap;
	font-weight: 500;
}

@font-face {
	font-family: Asap;
	src: local("Asap-Bold"), url("/static/fonts/Asap-SemiBold.ttf") format("truetype");
	font-style: normal;
	font-display: swap;
	font-weight: 600;
}

@font-face {
	font-family: Asap;
	src: local("Asap-Bold"), url("/static/fonts/Asap-Bold.ttf") format("truetype");
	font-style: normal;
	font-display: swap;
	font-weight: 700;
}

@font-face {
	font-family: "Alimama ShuHeiTi";
	src: url("/static/fonts/Alimama ShuHeiTi.ttf") format("truetype");
	font-style: normal;
	font-display: swap;
	font-weight: 700;
}

page {
	font-family: Asap, sans-serif !important;
	animation: animred .6s linear alternate forwards 0s;
}

/* #ifdef H5 */
/* H5 的 tabBar 不支持 backgroundImage，这里补上波浪底图，并把图标文字下移到底图实心区 */
uni-tabbar .uni-tabbar {
	background: url("/static/images/tabbar/tabbar_bg.png") no-repeat center bottom / 100% 100% transparent !important;
	backdrop-filter: none !important;
}

uni-tabbar .uni-tabbar-border {
	display: none;
}

uni-tabbar .uni-tabbar__bd {
	padding-top: 34px;
	box-sizing: border-box;
}

uni-page-head .uni-page-head__title {
	font-family: Asap, sans-serif;
	font-weight: 500;
}

uni-tabbar .uni-tabbar__label {
	line-height: 12px;
	font-family: Asap, sans-serif;
	font-weight: 400;
}
/* #endif */



/* #endif */
</style>
